import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _Icon;
import { forwardRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { FALLBACK_ICON, SVG_LIB_BASE_PATH } from '../Icon/icon-consts';
import { GRAY50, PRIMARY25 } from '../common';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var EMPTY_STATE_PATH = '/illustration/empty-state/';
var sizeMap = {
  lg: 92,
  sm: 62
};

/**
 * Renders an country svg image icon from the Zenith SVG library.
 */
export var EmptyStateIllustration = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? false : _ref$background,
    id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    src = _ref.src,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'primary' : _ref$style,
    sx = _ref.sx;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var alt = id.split('-').join(' ');
  var styleModifier = style === 'primary' ? '' : '_gray';
  var svgPath = "".concat(SVG_LIB_BASE_PATH).concat(EMPTY_STATE_PATH).concat(id).concat(styleModifier, ".svg");
  var svgSize = typeof size === 'string' ? sizeMap[size] : size;
  var srcToRender = function () {
    if (error) return '';
    if (src) return src;
    return svgPath;
  }();
  var handleImgError = function handleImgError() {
    if (!error) {
      setError(true);
    }
  };
  useEffect(function () {
    setError(false);
  }, [id]);
  return /*#__PURE__*/_jsx(Box, {
    "data-name": "Illustration-".concat(id),
    "data-testid": "Illustration-".concat(id),
    ref: ref,
    sx: _extends({
      alignItems: 'center',
      display: 'flex',
      height: size === 'lg' ? 144 : svgSize,
      justifyContent: 'center',
      padding: background ? 6 : 0,
      width: size === 'lg' ? 144 : svgSize
    }, background && {
      backgroundColor: style === 'primary' ? PRIMARY25 : GRAY50,
      borderRadius: '100%'
    }, sx),
    children: error ? _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      iconId: FALLBACK_ICON
    })) : /*#__PURE__*/_jsx("img", {
      alt: alt,
      height: svgSize,
      onError: handleImgError,
      src: srcToRender,
      width: svgSize
    })
  });
});